<template>
  <v-container
    class="fill-height section-container pa-1"
    fluid
    style="display: flex; justify-content: center"
  >
    <section v-if="loading_requests" class="loader-container">
      <Loader text="Cargando agenda" />
    </section>
    <!-- VISTA MOBILE -->
    <v-data-table
      v-if="!loading_requests"
      class="hidden-md-and-up"
      :headers="computedHeaders"
      :search="search"
      :items="computedVisits"
      must-sort
      sort-by="visit_date"
      style="width: 100%"
      :items-per-page="-1"
      hide-default-header
      hide-default-footer
      loading-text="Cargando listado..."
      no-data-text="No existen prácticas agendadas"
      no-results-text="No existen prácticas agendadas"
    >
      <!-- <template  BORRAR NO VA
        v-slot:header
      >
          <RequestItem :techReq="item" @show-request="showRequest(item)" />
            <tr>
              <th v-show="showColumn('visit_status')">ESTADO</th>
              <th v-show="showColumn('request_id')">ID</th>
              <th v-show="showColumn('arrival_time')">HORA DE INICIO</th>
              <th v-show="showColumn('service_name')"> TIPO DE PRÁCTICA:
              {{ $store.state.mobsUser ? "CATEGORÍA" : "SERVICIO" }}
              </th>
              <th v-show="showColumn('request.full_address')">DIRECCIÓN</th>
              <th v-show="showClientColumn('request.client.full_name')">
                CLIENTE
              </th>
              <th v-show="showColumn('request.neighborhood.city.name')">CIUDAD</th>
            </tr>
        </template> -->
        <template 
          v-slot:item="{ item }">
          <div v-if="item.isTitle">
            <h3 align="center" class="date">{{ formatDate(item.visit_date) }}</h3>
          </div>
          <VisitItem
            v-else
            :showDate="
              search || ($store.state.visit_type && $store.state.visit_type + '')
            "
            :visit="item"
            @show-visit="showRequest(item)"
          />
        </template>
    </v-data-table>
    <!-- FIN VISTA MOBILE -->

    <!-- VISTA DESKTOP -->
    <v-data-table
      v-if="!loading_requests"
      class="hidden-sm-and-down"
      :headers="computedHeaders"
      :search="search"
      :items-per-page="-1"
      :items="computedVisits"
      hide-default-header
      hide-default-footer
      sort-by="visit_date"
      must-sort
      style="width: 100%"
      loading-text="Cargando listado..."
      :no-data-text="mobsUser ? 'No existen prácticas agendadas' : 'No existen visitas agendadas'"
      :no-results-text="mobsUser ? 'No existen prácticas agendadas' : 'No existen visitas agendadas'"
    >
      <template v-slot:header>
        <tr>
          <th v-show="showColumn('request_id')">ID</th>
          <th v-show="showColumn('visit_type.id')">TIPO</th>
          <th v-show="showColumn('visit_status')">ESTADO</th>
          <th v-show="showClientColumn('client')">CLIENTE</th>
          <th v-show="showColumn('service_name')">SERVICIO</th>
          <th v-show="showColumn('request.full_address')">DIRECCIÓN</th>
          <th v-show="showColumn('visit_date')">FECHA</th>
          <th v-show="showColumn('arrival_time')">HORA DESDE</th>
          <th v-show="showColumn('departure_time')">HORA HASTA</th>
        </tr>
      </template>
      <template v-slot:item="{ item }">
        <tr 
          v-if="item.isTitle"
          class="dateRow"
          :class="{ today: formatDate(item.visit_date) == 'Hoy' }"
        >
          <td :colspan="8">{{ formatDate(item.visit_date) }}</td>
        </tr>
        <tr v-else @click="showRequest(item)" style="cursor: pointer">
          <td v-show="showColumn('request_id')">
            <v-row class="d-flex align-content-center"  style="flex-flow: nowrap; align-items: baseline">
              <template v-if="$store.state.app_display_scheme">
                <img
                  v-if="getItemScheme(item) == 'asistencia'"
                  class="mr-2"
                  src="../icons/asistencia.png"
                  height="20"
                  width="20"
                />
                <img
                  v-if="getItemScheme(item) == 'cliente-final'"
                  class="mr-2"
                  src="../icons/clientefinal.png"
                  height="20"
                  width="20"
                />
                <img
                  v-if="getItemScheme(item) == 'corpo'"
                  class="mr-2"
                  src="../icons/corporativo.png"
                  height="20"
                  width="20"
                />
                <img
                  v-if="getItemScheme(item) == 'fletes'"
                  class="mr-2"
                  src="../icons/fletes.png"
                  height="20"
                  width="20"
                />
                <img
                  v-if="getItemScheme(item) == 'inmobiliaria'"
                  class="mr-2"
                  src="../icons/inmobiliaria.png"
                  height="20"
                  width="20"
                />
                <img
                  v-if="getItemScheme(item) == 'mobs'"
                  class="mr-2"
                  src="../icons/corporativo.png"
                  height="20"
                  width="20"
                />
              </template>
              <span>{{ item.request_id }}</span>
            </v-row>
          </td>
          <td
            v-show="showColumn('visit_type.id')"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-start;
            "
            class="border-type"
          >
            <div
              :style="`margin-top: -2px; height: 12px; width: 12px; margin-right: 4px; border-radius: 50%; background-color: ${item.visit_type.backgroundColor}`"
            ></div>
            <span>{{ item.visit_type.label }}</span>
          </td>
          <td v-show="showColumn('visit_status')">
            <div
            style="
              display: flex;
              align-items: center;
              justify-content: flex-start;
            "
            >
              <v-icon color="warning" v-if="item.visit_status === 1">event</v-icon>
              <v-icon color="success" v-if="item.visit_status === 2">check</v-icon>
              <v-icon color="success" v-if="item.visit_status === 14"
                >check</v-icon
              >
              <v-icon
                color="warning"
                v-if="item.visit_status === 3 || item.visit_status === 4"
                >error_outline</v-icon
              >
              <v-icon color="success" v-if="item.visit_status === 8">home</v-icon>
              <v-icon color="success" v-if="item.visit_status === 12"
                >store</v-icon
              >
              <v-icon
                color="error"
                v-if="
                  item.visit_status === 5 ||
                  item.visit_status === 6 ||
                  item.visit_status === 7 ||
                  item.visit_status === 9 ||
                  item.visit_status === 10 ||
                  item.visit_status === 11 ||
                  item.visit_status === 13
                "
              >
                clear
              </v-icon>
              <span>
                {{ item.visit_status_name }}
              </span>
            </div>
          </td>
          <td v-show="showClientColumn('client')">
            {{ item.client ? item.client : "No disponible" }}
          </td>
          <td v-show="showColumn('service_name')">
            {{ item.service_name }}
          </td>
          <td v-show="showColumn('request.full_address')">
            {{ requestAddress(item) }}
          </td>
          <td
            v-show="showColumn('visit_date')"
            style="text-transform: capitalize"
          >
            {{ formatDate(item.visit_date) }}
          </td>
          <td v-show="showColumn('arrival_time')">{{ item.arrival_time }}</td>
          <td v-show="showColumn('departure_time')">
            {{ item.departure_time }}
          </td>
        </tr>
      </template>
    </v-data-table>
    <!-- FIN VISTA DESKTOP -->
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import VisitItem from "./VisitItem";
import Loader from "./Loader";
import HeadersVisits from "../assets/js/headersVisits";
import { HeadersMobsVisits } from "../assets/js/headersMobsVisits";

export default {
  name: "VisitList",

  components: {
    VisitItem,
    Loader,
  },

  data() {
    return {
      search: null,
      error_message: false,
      setTimeout: null,
      headersVisits: [],
    };
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "perform_search") {
        this.search = state.search;
      }
      if (mutation.type === "reset_search") {
        this.search = state.search;
      }
    });
  },

  mounted() {
    if (this.$store.state.mobsUser) {
      this.headersVisits = HeadersMobsVisits;
      this.$store.commit("set_app_title", "Mis prácticas");
    } else {
      this.headersVisits = HeadersVisits;
      this.$store.commit("set_app_title", "Eventos");
    }

    window.scrollTo(0, 0);

    this.setHeaders();
  },

  watch: {
    "$store.state.headers": function (val, old) {
      localStorage.setItem(
        "headersVisits",
        JSON.stringify(this.$store.state.headers)
      );
    },
    "$store.state.updateHeaders": function () {
      this.setHeaders();
    },
  },
  methods: {
    requestAddress(item) {
      const visitTechReq = this.$store.state.user_techReqs.find(
        (element) => element.id === item.request_technician
      );
      return visitTechReq.request.full_address;
    },

    setHeaders() {
      const _headers = localStorage.getItem("headersVisits");
      let headers;
      if (_headers === JSON.stringify(this.headersVisits)) {
        headers = JSON.parse(_headers);
      } else {
        localStorage.setItem(
          "headersVisits",
          JSON.stringify(this.headersVisits)
        );
        headers = this.headersVisits;
      }
      this.injectFilters(headers);
      this.$store.commit("set_headers", headers);
    },

    injectFilters(headers) {
      const filterType = (value) => {
        if (!this.$store.state.visit_type) return true;
        return value === this.$store.state.visit_type;
      };

      const filterStatus = (value) => {
        if (!this.$store.state.visit_status) return true;
        return value === this.$store.state.visit_status;
      };

      const index = headers.findIndex((item) => item.value === "visit_type.id");
      headers[index].filter = filterType;

      const indexStatus = headers.findIndex(
        (item) => item.value === "visit_status"
      );
      headers[indexStatus].filter = filterStatus;

      const indexB = this.headersVisits.findIndex(
        (item) => item.value === "visit_type.id"
      );
      this.headersVisits[indexB].filter = filterType;

      const indexStatusB = this.headersVisits.findIndex(
        (item) => item.value === "visit_status"
      );
      this.headersVisits[indexStatusB].filter = filterStatus;
    },

    getItemScheme(item) {
      const visitTechReq = this.$store.state.user_techReqs.find(
        (techReq) => techReq.id === item.request_technician
      );
      return visitTechReq.request.scheme;
    },

    showRequest(visit) {
      const selectedVisitTechReq = this.$store.state.user_techReqs.find(
        (techReq) => techReq.id === visit.request_technician
      );
      this.$router.push({
        name: "request-detail",
        query: { requestId: selectedVisitTechReq.request.id },
      });
    },

    showColumn(value) {
      const item = this.$store.state.headers.find(function (element) {
        return element.value === value;
      });
      if (item) return item.show;
      return null;
    },

    showClientColumn(value) {
      const item = this.$store.state.headers.find(function (element) {
        return element.value === value;
      });
      if (item && this.$store.state.app_display_username) return item.show;
      return null;
    },

    formatDate(date) {
      const _date = new Date();
      const today = moment(_date).format("YYYY-MM-DD");
        if (date === today) {
          return "Hoy";
        } else {
          return moment(date, "YYYY-MM-DD").format("dddd DD MMMM, YYYY");
          // return date;
        }
    },
  },
  computed: {
    mobsUser() {
      return this.$store.state.mobsUser
    },
    computedHeaders: function () {
      let _headers = this.headersVisits;
      if (!this.$store.state.app_display_username) {
        _headers = _headers.filter((item) => item.value !== "client");
      }
      return _headers;
    },
    computedVisits: function () {
      const _date = new Date();
      const yesterday = moment(_date).add(-1, 'days').format("YYYY-MM-DD");
      let dateList = [];
      let visitList = [];
      let formattedList = [];
      let techReqList = this.$store.state.user_techReqs;   

      techReqList.forEach((techReq) => {
        techReq.visit.forEach((visit) => {
          visitList.push(visit);
          const found = dateList.find((date) => date == visit.visit_date);
            if (!found) dateList.push(visit.visit_date);
        });
      });

      dateList.sort();

      dateList.forEach((date) => {
        if (date > yesterday) {
          formattedList.push({ isTitle: true, visit_date: date });
          const dateVisits = visitList.filter(
            (visit) => visit.visit_date == date
          );
          formattedList = [...formattedList, ...dateVisits];
        }
      });

      return formattedList;
    },
    ...mapState(["user_visits", "loading_requests"]),
  },
};
</script>

<style scoped>
img {
  width: 25px;
}
.border-type {
  border-bottom-color:transparent !important;
}
@media (max-width: 959px) {
  .v-divider {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .hidden-sm {
    display: none;
  }
  .section-container {
    padding: 12px 0 !important;
    background: #eeeeee;
  }
  .section-content {
    display: flex;
    flex-direction: column-reverse;
    overflow-y: scroll;
  }
  .date {
    text-align: center;
  }
}
@media (min-width: 960px) {
  .v-divider {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .section-container {
    padding: 0 !important;
  }
  .hidden-lg {
    display: none;
  }
  .date {
    text-align: left;
  }
}
.date {
  text-transform: capitalize;
  background: #eeeeee;
  padding-top: 24px;
}
.dateRow {
  background: #eeeeee;
  text-transform: capitalize;
  font-weight: bold;
}
.today {
  background: #e1f5fe;
}
.v-list-item__subtitle,
.v-list-item__title {
  overflow: visible !important;
}
.v-data-footer {
  padding: 0 !important;
}
.v-application--is-ltr .v-data-footer__select {
  margin-right: 0 !important;
}
.loader-container {
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
